
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/preview/services/[slug]",
      function () {
        return require("private-next-pages/preview/services/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/preview/services/[slug]"])
      });
    }
  